import { serviceModel } from "app/management/services/service-model";
import { ProductWorkActivitiesModel } from "./product-work-activities.model";
export class CedProductModel {
    prdId: string;
    prdCode: string;
    prdShortName: string;
    prdLongName: string;
    prdInactive: boolean;
    prdTerminationDate: string;
    prdEffectiveDate: string;
    prdCreatedBy: string;
    prdLastModifiedBy: string;
    productWorkActivities : ProductWorkActivitiesModel[]=[];
    dislayWorkActivity : boolean=false;
    specificWorkActivities:any;
    selected : boolean=false;
    selectedWorkActivityId:string;
    selectedWorkActivity : any;
    services: serviceModel[]=[];
    prdComment: string;
  }